export const success = 'Success';
export const warning = 'Warning';
export const error = 'Error';

export default function translateResult(value) {
  switch (value) {
    case success:
      return 'Bem-sucedido';
    case warning:
      return 'Alerta';
    default:
      return 'Falhou';
  }
}
